import { render, staticRenderFns } from "./bomDetailBody.vue?vue&type=template&id=62c64d5f&scoped=true&"
import script from "./bomDetailBody.vue?vue&type=script&lang=js&"
export * from "./bomDetailBody.vue?vue&type=script&lang=js&"
import style0 from "./bomDetailBody.vue?vue&type=style&index=0&id=62c64d5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c64d5f",
  null
  
)

export default component.exports